export default __webpack_public_path__ + "static/media/nft-4.d1477b6a.gif";